import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import TimeTablePrayerDocLinks from '../navlinks/PrayerTimeDocLinks';
import SinglePrayerDocLinks from '../navlinks/SinglePrayerDocLinks';

const SidebarDoc = () => {
  const location = useLocation();
  const isDocumentationPage = location.pathname === '/documentation';

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div className="w-64 bg-gray-800 text-white p-7 relative">
        
        {/* Docs Link at the Top */}
        <div className="relative mb-4">
          <NavLink
            to="/documentation"
            className="text-lg font-semibold text-white hover:text-blue-400 transition"
            style={{ outline: 'none', boxShadow: 'none' }} // Completely remove outline
          >
            The FivePrayer Docs
          </NavLink>

          {/* Blue Ping - Only when on the documentation page */}
          {isDocumentationPage && (
            <span className="absolute top-[-6px] left-[-6px] w-2.5 h-2.5 bg-blue-500 rounded-full"></span>
          )}
        </div>

        {/* Menu Title */}
        <div className="text-2xl font-bold mb-6">Menu</div>

        {/* Menu Links */}
        <SinglePrayerDocLinks />
        <TimeTablePrayerDocLinks />
      </div>
    </div>
  );
};

export default SidebarDoc;
